function Logo() {
    return (<div className="logo" />);
}

export default Logo;